import { Sidebar } from '@payaca/ambrosia';
import { FC, type JSX } from 'react';
import { useDispatch } from 'react-redux';
import DealMaterialsList from '../dealMaterialsList/DealMaterialsList';
import './DealMaterialsListDrawer.sass';

type Props = {
  dealId: number;
  isOpen: boolean;
  onClose?: () => void;
};

const DealMaterialsListDrawer: FC<Props> = ({
  isOpen,
  onClose,
  dealId,
}: Props): JSX.Element | null => {
  const dispatch = useDispatch();

  return (
    <Sidebar
      isOpen={isOpen}
      onClose={onClose}
      title="Required materials"
      className="deal-materials-list-drawer"
    >
      <Sidebar.Body className="p-4">
        <DealMaterialsList dealId={dealId} enablePurchaseBehaviour={false} />
      </Sidebar.Body>
    </Sidebar>
  );
};
export default DealMaterialsListDrawer;
